import {
  AmexStaticBanners,
  MicroMoments,
  PromotionalCards
} from '@com-delta-idp/mnx-skymiles-shared';

export interface PersonalizationEngineRequest {
  micromomentCampaignId: string;
  bannerCampaignId: string;
  offerCampaignId: string;
  membershipLevel: string;
  birthDay: boolean;
  sevenDaysBeforeBirthday: boolean;
  sevenDaysAfterBirthday: boolean;
  skyMilesAnniversary: boolean;
  ageRestrict: string;
  format: string;
  amexCardMember: string;
  newJoiner: boolean;
  profileSetUp: boolean;
  currentDate: string;
  skyclub: boolean;
}

export interface MultiplePersonalizationEngineResponse {
  'ng-skymiles:promotional-cards': PromotionalCards;
  'ng-skymiles:amex-banners': AmexStaticBanners;
  'ng-skymiles:micro-moments-v1': MicroMoments;
}
